/**
 * The screens that say for themselves that they could not load, and so are
 * left on screen when the phone loses the network.
 *
 * The app covers every screen with « pas de connexion » as soon as the phone
 * goes offline. On these three that hid a page already able to say « Impossible
 * de charger … » with its own « Réessayer », which brings the content back
 * once the network does, without reloading the whole app (Sofia's test of
 * 2.2.7, 27/10/2026). Any other screen keeps the offline cover.
 *
 * Matched on the path alone: a query string or a fragment does not change
 * which page it is.
 */
const SCREENS_WITH_THEIR_OWN_ERROR: RegExp[] = [/\/profile\/my-achievements$/, /\/profile\/my-xp$/, /\/member\/[^/]+$/];

export const theScreenSaysItsOwnError = (url: string): boolean => {
  const path = url.split(/[?#]/)[0];
  return SCREENS_WITH_THEIR_OWN_ERROR.some((screen) => screen.test(path));
};
